import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import eq from "../../../assets/images/equipo.png";
import Facebook from "../../../assets/images/facebook.png";
import Twitter from "../../../assets/images/twitter.png";
import Whatsapp from "../../../assets/images/whatsapp.png";
import Messanger from "../../../assets/images/messanger.png";
import Embed from "../../../assets/images/embed.png";

export default function BasicModal({ open, setOpen, setEmbedOpen }) {
  const handleClose = () => setOpen(false);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 504,
          height: 590,
          bgcolor: "#FFFFFF",
          boxShadow:
            "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
          padding: "26px 24px",
          borderRadius: "16px",
          paddingTop: "21px",
          outline: "none",
        }}
      >
        <CloseIcon
          onClick={handleClose}
          sx={{
            color: "text.primary",
            marginLeft: "2px",
            marginBottom: "17px",
            "&:hover": {
              cursor: "pointer",
            },
          }}
        />
        <Typography
          variant="h3"
          fontFamily="Inter"
          fontSize="22px"
          fontWeight="600"
          lineHeight="26px"
          color="black"
          sx={{ marginBottom: "24px" }}
        >
          Share this page
        </Typography>
        <Box
          sx={{
            display: "flex",
            columnGap: "16px",
            marginBottom: "24px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "inset 0px 0px 2px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              width: "60px",
              height: "60px",
            }}
          >
            <img
              src={eq}
              alt="equippo"
              style={{
                width: "44px",
                height: "44px",
                objectFit: "cover",
              }}
            />
          </Box>
          <Typography
            variant="subtitle1"
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="600"
            lineHeight="24px"
            color="text.primary"
          >
            Equippo
          </Typography>
        </Box>
        <Heading text="Social Media" />
        <Box
          sx={{
            display: "flex",
            columnGap: "48px",
            alignItems: "center",
            marginBottom: "32px",
            marginTop: "16px",
          }}
        >
          <Media image={Facebook} text="Facebook" />
          <Media image={Twitter} text="Twitter" />
        </Box>
        <Heading text="Messaging" />
        <Box
          sx={{
            display: "flex",
            columnGap: "48px",
            alignItems: "center",
            marginBottom: "32px",
            marginTop: "16px",
          }}
        >
          <Media image={Whatsapp} text="Whatsapp" />
          <Media image={Messanger} text="Messanger" />
        </Box>
        <Heading text="Embed" />
        <Box
          onClick={() => setEmbedOpen(true)}
          sx={{
            marginBottom: "32px",
            marginTop: "16px",
          }}
        >
          <Media image={Embed} text="Embed" />
        </Box>
        <Heading text="Copy Link" />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            border: "1px solid #CFCFCF",
            borderRadius: "3px",
            height: "46.29px",
            marginTop: "8px",
            paddingLeft: "13px",
            paddingRight: "5px",
          }}
        >
          <Typography
            variant="body2"
            fontFamily="Inter"
            fontSize="14px"
            fontWeight="400"
            lineHeight="20px"
            color="#616161"
          >
            https://www.machineryplanet.com/sellers/equippo
          </Typography>
          <Button
            variant="outlined"
            sx={{
              width: "67px",
              height: "36px",
              textTransform: "capitalize",
              borderColor: "#1F1F1F",
              padding: "8px 16px",
              "&:hover": {
                borderColor: "#1F1F1F",
                backgroundColor: "#1F1F1F",
              },
              "&:hover > p": {
                color: "white",
              },
            }}
          >
            <Typography
              variant="body2"
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              lineHeight="20px"
              color="#1F1F1F"
            >
              Copy
            </Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

function Heading({ text }) {
  return (
    <Typography
      variant="subtitle1"
      fontFamily="Inter"
      fontSize="16px"
      fontWeight="600"
      lineHeight="24px"
      color="black"
    >
      {text}
    </Typography>
  );
}

function Media({ image, text }) {
  return (
    <Box
      sx={{
        display: "flex",
        columnGap: "16px",
        "&:hover": {
          cursor: "pointer",
        },
      }}
    >
      <img
        src={image}
        style={{ width: "24px", height: "24px", objectFit: "cover" }}
      />
      <Typography
        variant="body1"
        fontFamily="Inter"
        fontSize="16px"
        fontWeight="400"
        lineHeight="24px"
        color="black"
      >
        {text}
      </Typography>
    </Box>
  );
}
